<template>
  <DefaultPage>
    <div class="forward">
      <div class="hero">
        <HeroTexture class="hero-texture" />
        <HeroTextureTwo class="hero-texture-two" />
        <div class="hero-flex-wrap">
          <div class="grid-x grid-margin-x align-middle">
            <div class="cell large-9 xlarge-7 xxlarge-6">
              <div class="hero__call">
                <h1
                  class="hero__headline"
                  data-aos="fade-right"
                  data-aos-duration="1000"
                >
                  The Path Forward
                </h1>
                <div
                  class="hero__call__content"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <p>Our Board of Directors provides strong governance, collaborates with the management team to oversee SVMIC's operations, and guides the company's strategic vision.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-for="(quote, index) in $bios">
        <div :key="quote.name">
          <section
            class="quote-section"
            :class="{ 'quote-section--last' : index === $quotes.length - 1 }"
          >
            <div
              class="quote"
              :class="{ 'quote--reversed' : index % 2 > 0 }"
            >
              <div class="quote-inner">
                <div class="grid-x grid-padding-x medium-up-2 align-center">
                  <div
                    class="cell"
                    :class="{ 'medium-order-2' : index % 2 > 0 }"
                    :data-aos="index % 2 > 0 ? 'fade-left' : 'fade-right'"
                    data-aos-duration="600"
                    data-aos-offset="400"
                  >
                    <div class="quote-photo">
                      <div
                        class="quote-photo__photo"
                        data-slider-photos
                      >
                        <img :src="quote.photos.bio" />
                      </div>
                    </div>
                  </div>
                  <div
                    class="cell"
                    :class="{ 'medium-order-1' : index % 2 > 0 }"
                    :data-aos="index % 2 > 0 ? 'fade-right' : 'fade-left'"
                    data-aos-duration="600"
                    data-aos-offset="400"
                  >
                    <div class="quote-content">
                      <div class="quote-content__author">
                        <div
                          class="quote-content__author-name"
                          v-html="quote.formattedName"
                        >
                        </div>
                        <div
                          class="quote-content__author-position"
                          v-html="quote.position.join('<br>')"
                        >
                        </div>
                      </div>
                      <p class="quote-content__quotation">
                        {{ quote.bio }}
                      </p>
                      <Button
                        class="quote-content__button"
                        arrow="right"
                        :set="name = quote.name.split(' ')[2].slice(0, -1)"
                        :href="quote.bioUrl"
                        target="_blank"
                      >
                        Read Dr. {{ name.slice(-1) === 's' ? name+'\'' : name+'\'s' }} Full Bio
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </template>
      <TheSubFooter nextRoute="/financials" />
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import Button from '@/components/control/Button';
import HeroTexture from '@/assets/texture-forward-hero.svg';
import HeroTextureTwo from '@/assets/texture-forward-hero-2.svg';

export default {
  name: 'ThePathForward',
  components: {
    DefaultPage,
    TheSubFooter,
    Button,
    HeroTexture,
    HeroTextureTwo,
  }
};
</script>
